import React from "react"

/**
 * @type {React.FC<React.SVGAttributes<SVGElement>>}
 */
export const Unchecked = props => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="7.5" y="7.5" width="25" height="25" rx="3.5" strokeWidth="3" />
  </svg>
)

/**
 * @type {React.FC<React.SVGAttributes<SVGElement>>}
 */
export const Checked = props => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="6" y="6" width="28" height="28" rx="5" />
    <path
      d="M12 19.5361L17.4998 25.2575C17.8906 25.664 18.54 25.6672 18.9348 25.2646L29 15"
      stroke="white"
      strokeWidth="3"
      strokeLinecap="round"
    />
  </svg>
)
